import logo from './logo.svg';
import './App.css';
import MyForm from './components/ConversationalForm/ConversationalForm';
import {Route, Routes, Switch} from "react-router-dom";
import Company from "./Company";

function App() {
    const hostname = window.location.hostname.split('.')[0]
    // console.log(hostname)
    //<Company company={hostname}/>
    return (
        /*<div className="App">
            {hostname === "demo" && <MyForm/>}
            {hostname !== "demo" && <Company company={hostname}/>}
        </div>*/

        <div className="App">
            <Company company="tmb"/>
        </div>
    );
}

export default App;
